import { Pill } from "@/components/podkit/status/Pill";
import type { PlainRunner } from "@/queries/runner-queries";
import { RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";
import { type FC, useMemo } from "react";

export const RunnerPhaseTag: FC<{ runner: PlainRunner; labelOverrides?: Partial<Record<RunnerPhase, string>> }> = ({
    runner,
    labelOverrides,
}) => {
    const { variant, name, tooltip } = useMemo(() => {
        const actual = runner.status?.phase;
        const message = runner.status?.message || "";
        const desired = runner.spec?.desiredPhase;

        switch (desired) {
            case RunnerPhase.DELETED:
                return {
                    variant: "danger" as const,
                    name: labelOverrides?.[RunnerPhase.DELETED] ?? "Pending deletion",
                };
        }

        switch (actual) {
            case RunnerPhase.ACTIVE:
                return {
                    variant: "success" as const,
                    name: labelOverrides?.[RunnerPhase.ACTIVE] ?? "Online",
                };
            case RunnerPhase.DEGRADED:
                return {
                    variant: "danger" as const,
                    name: labelOverrides?.[RunnerPhase.DEGRADED] ?? "Active (Degraded)",
                    tooltip: message,
                };
            case RunnerPhase.CREATED:
                return {
                    variant: "warning" as const,
                    name: labelOverrides?.[RunnerPhase.CREATED] ?? "Waiting to connect",
                };
            case RunnerPhase.DELETING:
                return {
                    variant: "danger" as const,
                    name: labelOverrides?.[RunnerPhase.DELETING] ?? "Pending deletion",
                };
            case RunnerPhase.INACTIVE:
                return {
                    variant: "danger" as const,
                    name: labelOverrides?.[RunnerPhase.INACTIVE] ?? "Offline",
                };
            case RunnerPhase.DELETED:
                return {
                    variant: "default" as const,
                    name: labelOverrides?.[RunnerPhase.DELETED] ?? "Deleted",
                };
            default:
                return {
                    variant: "default" as const,
                    name: "Unknown",
                };
        }
    }, [runner, labelOverrides]);

    return (
        <Pill variant={variant} tooltip={tooltip}>
            {name}
        </Pill>
    );
};
